module.exports = __webpack_public_path__ + "static/3-c7545115ee514a95b05e72e1a08153ff.jpg";